import React, { useState } from "react";
import { AITutorDualModePanel, type AITutorDualMode } from "./AITutorDualModePanel";
import type { TelegramUser } from "../types";
import type { Module } from "../types";
import type { ModulesMetadataItem } from "../types/chat";

interface AITutorCoursePanelProps {
  user: TelegramUser | null;
  courseSlug: string;
  courseTitle: string;
  modules: Module[];
  onClose: () => void;
  embedded?: boolean;
  onMinWidthChange?: (width: number) => void;
  asideMode?: AITutorDualMode;
  onAsideModeChange?: (mode: AITutorDualMode) => void;
}

function toModulesMetadata(modules: Module[]): ModulesMetadataItem[] {
  return modules.map((m) => ({
    id: m.id,
    title: m.title,
    description: m.description,
    lessons: m.lessons.map((l) => ({ id: l.id, title: l.title })),
  }));
}

export const AITutorCoursePanel = ({
  user,
  courseSlug,
  courseTitle,
  modules,
  onClose,
  embedded = false,
  onMinWidthChange,
  asideMode: asideModeProp,
  onAsideModeChange: onAsideModeChangeProp,
}: AITutorCoursePanelProps) => {
  const [internalMode, setInternalMode] = useState<AITutorDualMode>("chat");
  const asideMode = asideModeProp ?? internalMode;
  const onAsideModeChange = onAsideModeChangeProp ?? setInternalMode;

  const chatProps = {
    contextType: "course" as const,
    courseSlug,
    courseTitle,
    modulesMetadata: toModulesMetadata(modules),
    headerSubtitle: embedded ? "Спроси о курсе, навигации и темах." : undefined,
    showChatHistoryInEmbedded: embedded,
    enableFeedback: true,
    embedded,
    onMinWidthChange,
    hideHeader: false as const,
  };

  return (
    <AITutorDualModePanel
      user={user}
      onClose={onClose}
      embedded={embedded}
      onMinWidthChange={onMinWidthChange}
      mode={asideMode}
      onModeChange={onAsideModeChange}
      chatProps={chatProps}
    />
  );
};
